import ExtensionType from 'owa-service/lib/contract/ExtensionType';
import { ExtensionEntryPointEnum } from 'owa-addins-store';
import { ItemSendEventReason } from './enums/ItemSendEventReason';

export default {
    ExtAddinLaunched: {
        datapoint: {
            name: 'ExtAddinLaunched',
            customData: (
                id: string,
                name: string,
                module: string, //'Mail' | 'Calendar'
                scenario: string, //'Read' | 'Compose',
                extPoint: ExtensionEntryPointEnum,
                lang: string,
                type: ExtensionType,
                errorCode: number,
                delegate: boolean
            ) => {
                return {
                    id,
                    name,
                    owa_1: module,
                    owa_2: scenario,
                    owa_3: extPoint,
                    owa_4: type,
                    lang,
                    errorCode,
                    delegate,
                };
            },
        },
    },
    ExtDelegateAddinLaunched: {
        datapoint: {
            name: 'ExtDelegateAddinLaunched',
            customData: (
                id: string,
                name: string,
                module: string, // 'Mail' | 'Calendar'
                scenario: string // 'Read' | 'Compose'
            ) => {
                return {
                    id,
                    name,
                    owa_1: module,
                    owa_2: scenario,
                };
            },
        },
    },
    ExtItemSendEvent: {
        datapoint: {
            name: 'ExtItemSendEvent',
            customData: (
                reason: ItemSendEventReason,
                id?: string,
                name?: string,
                module?: string
            ) => {
                return {
                    owa_1: reason,
                    owa_2: module,
                    id,
                    name,
                };
            },
        },
    },
};
